export default "__VITE_ASSET__CTPJvzZV__"